import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { IconButton, Typography } from "@mui/material";
import { GetApp as GetAppIcon } from "@mui/icons-material";
import { useTranslation } from 'hooks';
import { formatDate } from 'utils/date';
import { shortTimeFormat } from 'constants/dateFormats';
import Link from '../../Link';
import styles from './Message.module.css';

const Message = (props) => {
  const { message, isMe } = props;
  const { t } = useTranslation();
  const position = isMe ? 'right' : 'left';
  const theme = isMe ? 'themePrimary' : 'themeDefault';
  const time = formatDate(message.posted, shortTimeFormat);

  const isAttacment = !!message.attachment;
  const hasFile = isAttacment || !!message.url;
  let fileUrl = null;
  if (isAttacment) fileUrl = message.attachment.fileUrl;
  else if (hasFile) fileUrl = message.url;

  return (
    <div
      className={cn(styles.root, {
        [styles[position]]: true,
      })}
    >
      <div
        className={cn(styles.body, {
          [styles[theme]]: true,
          [styles.hasFile]: hasFile && isMe,
        })}
      >
        {!isMe && (
          <Typography variant="body2" className={styles.sender}>
            {message.sender.name}
          </Typography>
        )}
        {hasFile && (
          <div className={styles.file}>
            <IconButton
              to={fileUrl}
              component={Link}
              color="primary"
              aria-label={t('downloadFile')}
              download
              classes={{ root: styles.fileIcon }}
            >
              <GetAppIcon />
            </IconButton>
          </div>
        )}
        <Typography variant="body1" classes={{ root: styles.content }}>
          {message.content}
        </Typography>
        <div className={styles.time}>{time}</div>
      </div>
    </div>
  );
};

Message.propTypes = {
  message: Type.shape({
    id: Type.string.isRequired,
    posted: Type.string.isRequired,
    content: Type.string.isRequired,
    sender: Type.shape({
      id: Type.string.isRequired,
      name: Type.string.isRequired,
    }).isRequired,
    attachment: Type.shape({
      fileName: Type.string.isRequired,
      fileType: Type.string.isRequired,
      fileUrl: Type.string.isRequired,
      mimeType: Type.string.isRequired,
    }),
    url: Type.string,
  }).isRequired,
  isMe: Type.bool.isRequired,
};

export default Message;
